import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import VergleichPage from "../pages/vergleich/page";
import SicherheitPage from "../pages/sicherheit/page";
import VersandPage from "../pages/versand/page";
import EinkaufsfuehrerPage from "../pages/einkaufsfuehrer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-ratgeber",
    element: <ArticlePage />,
  },
  {
    path: "/artikel/oopbuy-vergleich",
    element: <VergleichPage />,
  },
  {
    path: "/artikel/oopbuy-sicherheit",
    element: <SicherheitPage />,
  },
  {
    path: "/artikel/oopbuy-versand",
    element: <VersandPage />,
  },
  {
    path: "/artikel/oopbuy-einkaufsfuehrer",
    element: <EinkaufsfuehrerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;